import { render, staticRenderFns } from "./MsArticleLabel.vue?vue&type=template&id=54a67fcf&scoped=true&"
import script from "./MsArticleLabel.vue?vue&type=script&lang=js&"
export * from "./MsArticleLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a67fcf",
  null
  
)

export default component.exports